import {Subtitle1, Title1} from "@fluentui/react-components";

function Title({title, subtitle}) {
    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <Title1>{title}</Title1>
            { (subtitle == null) ? null : <Subtitle1>{subtitle}</Subtitle1> }
        </div>
    );
}

export default Title;